export const SET_NAV_ITEMS = 'SET_NAV_ITEMS';
export const SET_SIDE_NAV_ITEMS = 'SET_SIDE_NAV_ITEMS';
export const SET_DEFAULT_NAV = 'SET_DEFAULT_NAV';
export const SET_PREVIOUS_PAGE = 'SET_PREVIOUS_PAGE';
export const SET_NEXT_PAGE = 'SET_NEXT_PAGE';
export const CREATE_PAGINATION_LIST = 'CREATE_PAGINATION_LIST';